import {Injectable} from '@angular/core';
import {DexMdSubjectService} from '../subjects/dex-md-subject-service';
import {DexSecuritiesSubjectService} from '../subjects/dex-securities-subject-service';
import {ComputedTrancheRules} from '../types/computed/computed-tranche-rules';
import {TrancheId} from '../types/tranche';
import {TrancheRules} from '../types/tranche-rules';

@Injectable()
export class DexComputedTrancheRulesService {

    constructor(
        private readonly dexSecuritiesSubjectService: DexSecuritiesSubjectService,
        private readonly dexMdSubjectService: DexMdSubjectService
    ) {}

    public create(rules: TrancheRules): ComputedTrancheRules {

        // Let's assume, that it's the same for all child rules.
        const valueDeliverableId = rules.valueRules.valueDeliverableId
            || rules.depositRules.valueDeliverableId
            || rules.withdrawalRules.valueDeliverableId;

        return {
            raw:              rules,
            valueDeliverable: this.dexSecuritiesSubjectService.getDeliverableById(valueDeliverableId)
        };
    }

    public createByTrancheId(trancheId: TrancheId): ComputedTrancheRules {
        const rules = this.dexMdSubjectService.trancheRulesMapById.get(trancheId);

        return rules && this.create(rules);
    }

}
